<!--  -->
<template>
	<div class="container">
		<div class="search-container flex flex-between" ref="tableHeight">
			<div class="flex">
				<el-input v-model.trim="searchFrom.licensePlate" class="w190" size="small" placeholder="车辆" @keyup.enter.native="handleSearch"
					maxlength="16" clearable>
				</el-input>
				<el-date-picker class="ml15" size="small" v-model="dataValue" type="daterange" value-format="yyyy-MM-dd" @change="handleSearch()"
					range-separator="-" :editable="false" :clearable="false" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
				<el-select v-model="searchFrom.checkOpport" class="ml15 w190" size="small" placeholder="出车/回车" clearable @change="handleSearch()">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch()" alt="">
			</div>
			<!-- <div v-if="isEdit">
				<img class="icon-img ml7" src="@/assets/images/delete.png" @click="deleteRow" title="删除" alt="">
			</div> -->
		</div>
		<div class="table-container">
			<div v-if="tableData.length>0">
				<el-table ref="multipleTable" v-el-table-infinite-scroll="tableLoad" :infinite-scroll-distance="50"
					:infinite-scroll-immediate="false" :data="tableData" :height="height" :cell-style="cellStyle"
					:row-class-name="tabRowClassName"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
					:row-key="(row) => { return row.recordId}" @selection-change="handleSelectionChange" border
					style="width: 100%" @cell-click="editRow">
					<el-table-column type="selection" width="50" :reserve-selection="true" align="center">
					</el-table-column>
					<el-table-column prop="docCode" label="单号" width="180" sortable></el-table-column>
					<el-table-column prop="licensePlate" label="车辆" width="180" fixed sortable></el-table-column>
					<el-table-column prop="createdTime" label="日期时间" width="180" sortable>
						<template slot-scope="scope">
							{{dateTimeFormat(scope.row.createdTime)}}
						</template>
					</el-table-column>
					<el-table-column prop="checkOpport" label="出车(Y)/回车(N)" width="180" sortable></el-table-column>
					<el-table-column prop="kilometrage" label="里程数(km)" width="180" sortable></el-table-column>
					<el-table-column prop="etcCode" label="ETC编码" width="190" sortable></el-table-column>
					<el-table-column prop="etcMoney" label="ETC金额" width="180"></el-table-column>
					<el-table-column prop="etcBalance" label="ETC余额" width="180"></el-table-column>
					<el-table-column prop="planDate" label="计划日期" width="180" sortable>
						<template slot-scope="scope">
							{{scope.row.planDate?dateFormat(scope.row.planDate):''}}
						</template>
					</el-table-column>
					<el-table-column prop="planCode" label="巡回计划" width="180" sortable></el-table-column>
					<el-table-column prop="routeName" label="路线" width="180" fixed sortable></el-table-column>
					<el-table-column prop="createdName" label="制单员" width="180" sortable></el-table-column>
				</el-table>
			
			</div>
			<el-empty v-else :style="{height:height+'px'}" description="暂无数据"></el-empty>
			<div class="flex flex-between search-container">
					<div class="totalPage">
						当前第<span class="page-active">{{currentNo}}</span>页，共<span class="page-active">{{totalCount}}</span>条数据，共<span class="page-active">{{totalPage}}</span>页
					</div>
				<img class="icon-img" style="vertical-align: middle;" src="@/assets/images/down.png"
					@click="download" title="导出" alt="">
			</div>
		</div>
		<!-- 编辑 -->
		<refuelInfo ref="refuelInfo"></refuelInfo>
	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
	import refuelInfo from './components/refuel-info.vue'
	import {
		dateTimeFormat
	} from '@/utils/common'
	import {
		dateFormat
	} from '@/utils/common'
	import { hasPermission } from '@/utils/permission'
	export default {
		name:'mileage',
		components: {
			refuelInfo
		},
		data() {
			return {
				searchFrom: {
					licensePlate: "",
					dateStart: "",
					dateEnd: "",
					checkOpport: "",
				},
				tableData: [],
				multipleSelection: [],
				options: [{
					value: 'Y',
					label: '出车Y'
				}, {
					value: 'N',
					label: '回车N'
				}, ],
				dataValue: '',
				height: 500,
				pageNo: 1,
				pageSize: 30,
				dateTimeFormat: null,
				dateFormat:null,
				infiniteFlag: false,
				isEdit:false,
				totalPage:"",
				totalCount:"",
				currentNo:"",
			}
		},
		created() {
			this.multipleSelection = []
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
			this.dataValue = [dateFormat(start), dateFormat(end)]
			this.getList()
			this.dateTimeFormat = dateTimeFormat
			this.dateFormat = dateFormat
			if (this.$route.meta.perm) {
				this.isEdit = hasPermission(this.$route.meta.perm);
				// console.log(this.isEdit)
			}

		},
		mounted() {
			let height = this.$refs.tableHeight.offsetHeight;
			this.height = window.innerHeight - 126 - height;
		},
		methods: {
			tabRowClassName({
				row,
				rowIndex
			}) {
				let index = rowIndex + 1;
				if (index % 2 == 1) {
					return 'warning-row'
				}
			},
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 1) {
					return 'cursor: pointer;'
				}
			},
			// 表格滚动加载
			tableLoad: debounce(function () {
				this.pageNo++;
				this.getList('scroll');
			}, 100, true),
			// 获取列表
			getList(type) {
				if(this.infiniteFlag) {
					return
				}
				let that = this;
				that.$request.post(
						"kilometrageList",
						true, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							dateStart: that.dataValue ? that.dataValue[0] : '',
							dateEnd: that.dataValue? that.dataValue[1] : '',
							licensePlate: that.searchFrom.licensePlate,
							checkOpport: that.searchFrom.checkOpport
						}
					)
					.then((res) => {
						if(res.data){
							that.infiniteFlag = res.data.totalPage <= that.pageNo;
						}
						if (type == 'scroll') {
							that.tableData = that.tableData.concat(res.data && res.data.list || []);
							that.totalPage=res.data.totalPage
								that.totalCount=res.data.totalCount
								that.currentNo = res.data.pageNo
						} else {
							if (res.data && res.data.list) {
								that.tableData = res.data.list
								that.totalPage=res.data.totalPage
								that.totalCount=res.data.totalCount
								that.currentNo = res.data.pageNo
							} else {
								that.tableData = []
								that.totalPage=0
								that.totalCount=0
								that.currentNo = 0
							}
						}
					})
			},
			handleSearch() {
				this.infiniteFlag = false;
				this.pageNo = 1
				this.$nextTick(() => {
					this.getList()
				})
				if (this.tableData.length > 0) {
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}

			},
			// 列多选
			handleSelectionChange(val) {
				console.log(val)
				this.multipleSelection = val;
			},
			// 查看/编辑
			editRow(row, column, cell, event) {
				if (column.label == '车辆') {
					this.$refs.refuelInfo.init(row)
				} else {
					this.$refs.multipleTable.toggleRowSelection(row);
				}
			},
			// 删除
			deleteRow() {
				let that = this;
				if (that.multipleSelection.length <= 0) {
					this.$message.error('请先选择!');
					return
				}
				let recordIds = []
				that.multipleSelection.forEach(item => {
					recordIds.push(item.recordId)
				});
				that.$confirm('是否确认删除？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					that.$request.post(
							"kilometrageDelete",
							false, {
								ids: recordIds,
							}
						)
						.then((res) => {
							if (res) {
								that.$message.success("删除成功！");
								that.handleSearch()
							}
						})
				}).catch(() => {});
			},
			// 导出
			download() {
				let that = this;
					let recordIds = []
				that.multipleSelection.forEach(item => {
					recordIds.push(item.recordId)
				});
				that.$request.post(
						"kilometrageExport",
						true, {
							pageNo: 1,
							pageSize: 50000,
							recordIds:recordIds,
							dateStart: that.dataValue ? that.dataValue[0] : '',
							dateEnd: that.dataValue? that.dataValue[1] : '',
							licensePlate: that.searchFrom.licensePlate,
							checkOpport: that.searchFrom.checkOpport
						}
					)
					.then((res) => {
						if (res) {
							let downloadURL = res.data
							const linkNode = document.createElement('a');
							linkNode.style.display = 'none';
							linkNode.href = downloadURL;
							document.body.appendChild(linkNode);
							linkNode.click(); //模拟在按钮上的一次鼠标单击
							URL.revokeObjectURL(linkNode.href); // 释放URL 对象
							document.body.removeChild(linkNode);
						}
					})
			},

		},
	}

</script>

<style lang='scss' scoped>
	.container {
		background: #fff;
		box-sizing: border-box;
		margin: 12px 26px 15px 10px;
		// padding-bottom: 20px;

		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 0px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
			/deep/ th .el-table__cell{
				padding: 0 !important;
			}
		}
	}

	.red {
		width: 50px;
		height: 20px;
		background: #D9001B;
	}

	.blue {
		width: 50px;
		height: 20px;
		background: #02A7F0;
	}

	.search-container {
		padding: 8px;
	}

</style>
